var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('Nav'),_c('TicketFilter'),_c('b-row',_vm._l((_vm.sortedTickets),function(ticket){return _c('TicketCard',{key:'ticket-' + ticket.id,attrs:{"ticket":ticket}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }